// "Four Ways To Be Wrong" — one question, four real RAG bugs, four fixes.
// Product-visual rebuild: faithful EAKC chat-UI mockups (reasoning trace, the
// real "The E" quality card, the admin-tour answer, code diffs). Cold Compute kit.
// ~127s @ 30fps.
//
// GROUNDED in the EAKC-MVP 2026-06-15 chat-quality session (every screen is real):
//   1. Cross-source grounding leak — citations all EAKC, prose about a different
//      tenant codebase ("Financial Services" trading system). Fix: turn-scope
//      hard filter (route.ts).
//   2. Premature stop — "Response generated: 2 words", answer = "The E". Cause:
//      provider:{sort:'throughput'} routed to a Gemini server that ignored
//      reasoning:{enabled:false}. Fix: reverted the routing.
//   3. Wrong subsystem — answered "## Major Subsystems" = admin/diagnostics, jobs,
//      tenants, users, webhooks. Cause: File Index ranked by PageRank only.
//      Fix: relevance-bias the File Index.
//   4. Knew-but-shipped — CRAG graded INCORRECT (0.90), HyDE Fallback skipped,
//      synthesised anyway. Fix: cheap broader-search safety net.
//   + Measured the residual retrieval miss as an /admin/eval golden case.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous.
export const SCENE = {
  hook: { start: 0, duration: 480 }, //       0:00–0:16   the question, in the real chat UI
  leak: { start: 480, duration: 600 }, //     0:16–0:36   wrong PROJECT — cross-source leak
  stop: { start: 1080, duration: 540 }, //    0:36–0:54   wrong LENGTH — the "The E" stop
  room: { start: 1620, duration: 660 }, //    0:54–1:16   wrong ROOM — the admin tour
  crag: { start: 2280, duration: 540 }, //    1:16–1:34   knew-but-shipped — CRAG safety net
  measure: { start: 2820, duration: 480 }, // 1:34–1:50   measure the residual miss
  outro: { start: 3300, duration: 510 }, //   1:50–2:07   four fixes, one rule
} as const;

export const TOTAL_DURATION = 3810; // 127s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
